import React from 'react'
import PaywallBuddy from '../../images/paywall-buddy.svg'
import { InfoIcon } from 'components/Utils/Icons'
import { Button, Text } from 'components/base'
import SectionPlaceholder from './Section'
import { SearchIcon } from 'components/Utils/Icons'

import { connect } from 'react-redux'
import { goToOrganizationUpgrade } from 'data/ui/actions'

function AnalyticsPaywall({ goToOrganizationUpgrade }) {
  return (
    <main className="analytics-paywall padding-top-huge">
      <div className="analytics-illustration-and-button flexbox flexbox-align-center flexbox-column">
        <img src={PaywallBuddy} alt="Analytics paywall illustration" />
        <Text.Corpus className="margin-top-large">
          See your team’s activity and which content they’re looking for.
        </Text.Corpus>
        <Button.Primary
          className="margin-top-large margin-bottom-huge"
          onClick={() => {
            goToOrganizationUpgrade({ incentiveId: 'organizationAnalytics' })
          }}
        >
          <InfoIcon />
          <span className="margin-horizontal-normal">
            Upgrade to enable insights
          </span>
        </Button.Primary>
      </div>

      <div className="flexbox flexbox-space-between margin-bottom-huge shade-30">
        <SectionPlaceholder
          title="Notes"
          firstCallout="Popular"
          rowsTitle="Note"
          rowsValueLabel="Views"
        />
        <SectionPlaceholder
          title="Team activity"
          firstCallout="Top writers"
          secondCallout="Top readers"
          rowsTitle="Member"
          rowsValueLabel="Edits"
          renderPlaceholderIcon={() => (
            <div
              style={{ height: 24, width: 24, borderRadius: '100%' }}
              className="radius-full background-shade-50 margin-right-small"
            />
          )}
        />
      </div>

      <div className="flexbox flexbox-space-between margin-bottom-huge">
        <SectionPlaceholder
          title="Searches"
          firstCallout="Popular"
          secondCallout="Failed"
          rowsTitle="Term"
          rowsValueLabel="Searches"
          renderPlaceholderIcon={() => (
            <SearchIcon className="shade-30 margin-right-small" />
          )}
        />
        <SectionPlaceholder
          title="&nbsp;"
          firstCallout="&nbsp;"
          rowsTitle="Popular match"
        />
      </div>
    </main>
  )
}

export default connect(
  null,
  { goToOrganizationUpgrade }
)(AnalyticsPaywall)
